import { observable, action, computed, configure, runInAction } from "mobx";
import { createContext } from "react";
import { IFttbHour } from "../models/fttbhour";
import { ITechnician } from "../models/technician";
import { toast } from "react-toastify";
import agent from "../api/agent";

configure({ enforceActions: "always" });

class FttbHourStore {
  @observable fttbhourRegistry = new Map();
  @observable fttbhour: IFttbHour | null = null;
  @observable fttbhourList: IFttbHour[] = new Array();
  @observable fttbhourTech: IFttbHour[] = new Array();
  @observable payrollcycleRegistry = new Map();
  @observable technicianRegistry = new Map();
  @observable technician: ITechnician | null = null;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = "";

  @computed get fttbhournamesByDate() {
    return Array.from(this.fttbhourRegistry.values()).sort(
      (a, b) => Date.parse(a.date) - Date.parse(b.date)
    );
  }

  @computed get techniciansByName() {
    return Array.from(this.technicianRegistry.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }

  @computed get payrollcyclesByName() {
    return Array.from(this.payrollcycleRegistry.values()).sort(
      (a, b) =>
        a.startYear.localeCompare(b.startYear) ||
        a.endYear.localeCompare(b.endYear) ||
        a.payRun.localeCompare(b.payRun)
    );
  }

  @action loadFttbHourTechs = async () => {
    this.loadingInitial = true;
    try {
      const fttbhours = await agent.FttbHours.list();
      //console.log(fttbhours);
      runInAction("loading fttbhours", () => {
        // fttbhours.forEach(fttbhour => {
        //   this.fttbhourRegistry.set(fttbhour.id, fttbhour);
        // });
        this.fttbhourTech = fttbhours;
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load FttbHour List error", () => {
        this.loadingInitial = false;
      });
      toast.error("load FttbHour List error");
    }
  };

  @action searchFttbHours = async (search: {
    tech: string;
    payRun: string;
    jobStartDate: string;
    jobEndDate: string;
    orderNo: string;
  }) => {
    if (
      search.tech === "" &&
      search.payRun === "" &&
      search.jobStartDate === "" &&
      search.jobEndDate === "" &&
      search.orderNo === ""
    ) {
      toast.info("Please select at least one search condition");
      return;
    } else if (search.jobStartDate !== "" && search.jobEndDate === "") {
      toast.info("Please select job end date");
      return;
    } else if (search.jobEndDate !== "" && search.jobStartDate === "") {
      toast.info("Please select job start date");
      return;
    }
    const params = new URLSearchParams();
    params.append("tech", search.tech);
    params.append("payRun", search.payRun);
    params.append("jobStartDate", search.jobStartDate);
    params.append("jobEndDate", search.jobEndDate);
    params.append("orderNo", search.orderNo);

    this.loadingInitial = true;
    try {
      const fttbhours = await agent.FttbHours.search(params);
      this.fttbhourRegistry.clear();
      runInAction("loading fttbhours", () => {
        fttbhours.forEach((fttbhour) => {
          if (fttbhour.date !== null)
            fttbhour.date = fttbhour.date.substr(0, 10);
          this.fttbhourRegistry.set(fttbhour.id, fttbhour);
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load FttbHour List error", () => {
        this.loadingInitial = false;
      });
      toast.error("load FttbHour List error");
    }
  };

  @action loadFttbHour = async (id: string) => {
    let fttbhour = this.getFttbHour(id);
    if (fttbhour) {
      this.fttbhour = fttbhour;
      return fttbhour;
    } else {
      this.loadingInitial = true;
      try {
        const fttbhour = await agent.FttbHours.details(id);
        runInAction("getting fttbhour", () => {
          if (fttbhour.date) {
            fttbhour.date = fttbhour.date.substr(0, 10);
          }
          this.fttbhour = fttbhour;
          this.loadingInitial = false;
        });
        return fttbhour;
      } catch (error) {
        runInAction("get fttbhour error", () => {
          this.loadingInitial = false;
        });
        toast.error("get fttbhour error");
        console.log(error);
      }
    }
  };

  @action clearFttbHour = () => {
    this.fttbhour = null;
    this.fttbhourList.length = 0;
  };

  getFttbHour = (id: string) => {
    return this.fttbhourRegistry.get(Number(id));
  };

  // @action createFttbHour = async (fttbhour: IFttbHour) => {
  //   this.submitting = true;
  //   try {
  //     fttbhour.createdAt = new Date().toJSON();
  //     fttbhour.updatedAt = new Date().toJSON();
  //     const fttbhourname = await agent.FttbHours.create(fttbhour);
  //     runInAction('create Techncian', () => {
  //       this.fttbhournameRegistry.clear();
  //         this.fttbhourname = fttbhourname;
  //         if (fttbhourname.expiryDate !== null)  fttbhourname.expiryDate = fttbhourname.expiryDate.substr(0,10);
  //         this.fttbhournameRegistry.set(fttbhourname.id, fttbhourname);
  //       this.submitting = false;
  //     })
  //   } catch (error) {
  //     runInAction('create FttbHour error', () => {
  //       this.submitting = false;
  //     })
  //     toast.error('create FttbHour error');
  //     console.log(error);
  //   }
  // };

  @action createFttbHour = async (fttbhour: IFttbHour[]) => {
    this.submitting = true;
    try {
      await agent.FttbHours.create(fttbhour);
      runInAction("create Techncian", () => {
        this.submitting = false;
      });
    } catch (error) {
      runInAction("create FttbHour error", () => {
        this.submitting = false;
      });
      toast.error("create FttbHour error");
      console.log(error);
    }
  };

  @action editFttbHour = async (fttbhour: IFttbHour) => {
    this.submitting = true;
    try {
      await agent.FttbHours.update(fttbhour);
      runInAction("editing fttbhour", () => {
        this.fttbhourRegistry.set(fttbhour.id, fttbhour);
        this.fttbhour = fttbhour;
        this.submitting = false;
      });
    } catch (error) {
      runInAction("edit fttbhour error", () => {
        this.submitting = false;
      });
      toast.error("edit fttbhour error");
      console.log(error);
    }
  };

  @action deleteFttbHour = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.FttbHours.delete(id);
      runInAction("deleting FttbHour", () => {
        this.fttbhourRegistry.delete(id);
        this.submitting = false;
        this.target = "";
      });
    } catch (error) {
      runInAction("delete FttbHour error", () => {
        this.submitting = false;
        this.target = "";
      });
      toast.error("delete FttbHour error");
      console.log(error);
    }
  };

  @action importFttbHours = async (data: any) => {
    var rowno = 0;
    try {
      this.fttbhourList.length = 0;
      data.forEach((fttbhours: any) => {
        rowno = rowno + 1;
        const fttbhour: IFttbHour = {
          id: "0",
          createdAt: "",
          updatedAt: "",
          financialYear: fttbhours["Financial Year"],
          payRun: fttbhours.PayRun,
          date: fttbhours.Date,
          orderNumber: fttbhours["Order No"],
          hours: fttbhours.Hours,
          code: fttbhours.Code,
          tech: fttbhours.Tech,
          note: fttbhours.Note,
        };

        if (fttbhour.date == null) {
          fttbhour.date = "";
        } else {
          if (!isNaN(Number(fttbhour.date))) {
            let d = new Date(
              (parseInt(fttbhour.date) - 25569) * 86400 * 1000
            );
            const pad = (s: number) => {
              return s < 10 ? "0" + s : s;
            };
            fttbhour.date = [
              d.getFullYear(),
              pad(d.getMonth() + 1),
              pad(d.getDate()),
            ].join("-");
          } else {
            let parts = fttbhour.date.split("/");
            fttbhour.date =
              parts[2] +
              "-" +
              (parseInt(parts[1]) < 10 ? "0" : "") +
              parseInt(parts[1]) +
              "-" +
              (parseInt(parts[0]) < 10 ? "0" : "") +
              parseInt(parts[0]);
          }
          var regEx = /^\d{4}-\d{2}-\d{2}$/;
          if (
            fttbhour.date.match(regEx) === null ||
            Date.parse(fttbhour.date) > Date.now()
          )
            throw "Invalid date";
        }
        this.fttbhourList.push(fttbhour);
      });
      toast.success(
        `${this.fttbhourList.length} records successfully imported`
      );
    } catch (error) {
      toast.error(`import excel error, row #${rowno} has data format problem.`);
    }
  };

  @action loadPayrollCycles = async () => {
    this.loadingInitial = true;
    try {
      const payrollcycles = await agent.PayrollCycles.list();
      runInAction("loading payroll cycles", () => {
        payrollcycles.forEach((payrollcycle) => {
          this.payrollcycleRegistry.set(
            payrollcycle.startYear +
              "-" +
              payrollcycle.endYear +
              "-" +
              payrollcycle.payRun,
            payrollcycle
          );
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load payroll cycles error", () => {
        this.loadingInitial = false;
      });
      toast.error("load payroll cycles error");
    }
  };
}

export default createContext(new FttbHourStore());
